import {enumType} from 'common/enumType';

const ftVerifyType = (id: string, name: string) => ({id, name});

export const FileTransferVerifyType = enumType({
   SIZE: ftVerifyType('SIZE', 'File Size'),
   HASH: ftVerifyType('HASH', 'Checksum (SHA-256)'),
   NONE: ftVerifyType('NONE', 'None'),
});
